module.exports = __webpack_public_path__ + "img/activeSet7.fecbaa39.png";